import { render, staticRenderFns } from "./crearcolegio.vue?vue&type=template&id=473eb597"
import script from "./crearcolegio.vue?vue&type=script&lang=js"
export * from "./crearcolegio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports